export const LATEST_SCROLL_THRESHOLD_PX = 24;
export function isFollowingLatest(scrollTop, threshold = LATEST_SCROLL_THRESHOLD_PX) {
    return scrollTop <= threshold;
}
export function countAddedItems(previousItemIds, nextItemIds) {
    const previousIds = new Set(previousItemIds);
    return nextItemIds.reduce((count, itemId) => count + (previousIds.has(itemId) ? 0 : 1), 0);
}
export function getNextUnreadCount({ currentUnreadCount, previousItemIds, nextItemIds, followingLatest }) {
    if (followingLatest) {
        return 0;
    }
    return currentUnreadCount + countAddedItems(previousItemIds, nextItemIds);
}
export function getAnchorScrollAdjustment(previousViewportTop, nextViewportTop) {
    return nextViewportTop - previousViewportTop;
}
